module.exports = __webpack_public_path__ + "static/media/financepeer.ec6eaefe.jpg";